import React from 'react';

// --- Re-usable SVG Icons for a clean look ---
const MailIcon = (props) => (
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const LinkedInIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

// --- IMPROVED CONTACT FORM COMPONENT ---
// No more internal title. This component is now purely for the form and contact details.
const ContactForm = ({ t, colors }) => {
  return (
    <div className="grid md:grid-cols-2 gap-x-16 gap-y-12 items-start">
      
      {/* Left side: The Form */}
      <form action="https://formspree.io/f/myzpzdnn" method="POST" className="space-y-6">
        <div>
          <label htmlFor="name" className="block text-sm font-semibold mb-2">{t.form_name_label || 'Full Name'}</label>
          <input 
            type="text" id="name" name="name" placeholder="Your Name" required 
            className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-colors duration-300" 
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-semibold mb-2">{t.form_email_label || 'Email Address'}</label>
          <input 
            type="email" id="email" name="email" placeholder="you@example.com" required 
            className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-colors duration-300" 
          />
        </div>
        <div>
          <label htmlFor="message" className="block text-sm font-semibold mb-2">{t.form_message_label || 'Tell us about your project'}</label>
          <textarea 
            id="message" name="message" rows="5" placeholder="Hi, I'd like to talk about..." required 
            className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-colors duration-300"
          ></textarea>
        </div>
        <button type="submit" className="w-full syne-font text-lg font-bold text-white px-10 py-4 rounded-full shadow-lg transition-transform hover:scale-105" style={{ backgroundColor: colors.primary }}>
          {t.form_submit_btn || 'Send Message'}
        </button>
      </form>

      {/* Right side: Sleek Contact Card */}
      <div className="text-left bg-gray-800/50 border border-gray-700 rounded-2xl p-8 space-y-8">
        <h3 className="syne-font text-xl font-bold">Contact Details</h3>
        <div className="space-y-6">
          <a href="mailto:braziliawork@gmail.com" className="flex items-center group">
            <div className="flex-shrink-0 h-12 w-12 bg-gray-700/60 rounded-full flex items-center justify-center transition-colors duration-300 group-hover:bg-indigo-600/50">
              <MailIcon className="h-6 w-6 text-gray-300 transition-colors duration-300 group-hover:text-white"/>
            </div>
            <div className="ml-4">
              <p className="font-bold text-lg text-white">Email</p>
              <p className="text-gray-400 transition-colors duration-300 group-hover:text-white">braziliawork@gmail.com</p>
            </div>
          </a>
          <a href="https://www.linkedin.com/in/amina-askar-86475a370/" target="_blank" rel="noopener noreferrer" className="flex items-center group">
             <div className="flex-shrink-0 h-12 w-12 rounded-full flex items-center justify-center bg-[#0A66C2] transition-transform duration-300 group-hover:scale-110">
              <LinkedInIcon className="h-6 w-6 text-white"/>
            </div>
            <div className="ml-4">
              <p className="font-bold text-lg text-white">LinkedIn</p>
              <p className="text-gray-400 transition-colors duration-300 group-hover:text-white">Amina Askar</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;